import alertEventApi from '@/api/alertEvent.api'

export const alertEventService = (function () {
  'use strict'

  const EMAIL_LIST_REGEX = /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W]*$/

  /**
   * Para obtener los datos de las cosas para la tabla del ABM
   * @param {*} pageSize
   * @param {*} pageNumber
   * @param {*} enterprises
   * @param {*} types
   * @param {*} typesEvents
   */
  async function findAll(pageSize, pageNumber, enterprises, types, typesEvents) {
    if (enterprises && types && typesEvents) {
      try {
        const response = await alertEventApi.findAll(pageSize, pageNumber, enterprises, types, typesEvents)
        return response.data
      } catch (exception) {
        console.log(exception)
        return {
          data: [],
          headers: []
        }
      }
    } else {
      return {
        data: [],
        headers: []
      }
    }
  }


  /**
   *
   *  Datos para la tabla del ABM de tipos de eventos
   */
  // eslint-disable-next-line no-unused-vars
  async function findAllSuccessfulAlerts(pageSize, pageNumber, notificationsData, eventIds, thingIds) {
    try {
      const customEmails = [];
      const userNotifications = [];
      for (const notification of notificationsData) {
        if (notification.isCustom) {
          customEmails.push(notification);
        } else {
          userNotifications.push(notification.id);
        }
      }
      // const finalNotificationByUser = notificationsData.filter(notificationData => !notificationData.isCustom);
      // const usersId = finalNotificationByUser.map(notification => notification.id);
      let notificationsValidated = await alertEventApi.findAllSuccessfulAlerts(undefined, undefined, userNotifications, eventIds, thingIds);
      const notificationsValidMap = getNotificationValidatedMap(notificationsValidated.data);
      const customNotifications = getNofiticationCustom(customEmails, notificationsValidMap);
      notificationsValidated.data.validAlertEvents = notificationsValidated.data.validAlertEvents.concat(customNotifications);
      return notificationsValidated;
      // return response.data
    } catch (exception) {
      console.log(exception)
      return {
        data: [],
        headers: []
      }
    }
  }
  // eslint-disable-next-line no-unused-vars
  async function generateKey(notificationsData, eventIds, thingIds) {
      const key = (Math.random() + 1).toString(36).substring(2);
      
      const customEmails = [];
      const userNotifications = [];
      for (const notification of notificationsData) {
        if (notification.isCustom) {
          customEmails.push(notification);
        } else {
          userNotifications.push(notification.id);
        }
      }
      
      alertEventApi.findAllSuccessfulAlerts(undefined, undefined, userNotifications, eventIds, thingIds, key);
      return key;
  }

  async function findAlertsByKey(notificationsData, key) {
      const customEmails = [];
      const userNotifications = [];
      for (const notification of notificationsData) {
        if (notification.isCustom) {
          customEmails.push(notification);
        } else {
          userNotifications.push(notification.id);
        }
      }
      
      let notificationsValidated = await alertEventApi.findAlertsByKey(key);
      
      const notificationsValidMap = getNotificationValidatedMap(notificationsValidated.data);
      const customNotifications = getNofiticationCustom(customEmails, notificationsValidMap);
      notificationsValidated.data.validAlertEvents = notificationsValidated.data.validAlertEvents.concat(customNotifications);

      return notificationsValidated;
  }


  function getNotificationValidatedMap(notificationList) {
    const result = {};
    for (const alertValid of notificationList.validAlertEvents) {
      if (!result[alertValid.thingId]) {
        result[alertValid.thingId] = new Set();
      }
      result[alertValid.thingId].add(alertValid.eventType);
    }
    return result;
  }

  /*
  "thingId": "5f2c26f2116bc53550dd8fbc",
  "userId": "5dd678226057589f62c91fc3",
  "eventType": "STOPPED",
  "eventId": "5e5fcaf1a2c651e4d8fcced0",
  "alertType": "push"
  */
  function getNofiticationCustom(customEmails, notificationsValidMap) {
    const result = [];
    if (customEmails) {
      for (const thingId of Object.keys(notificationsValidMap)) {
        for (const eventType of notificationsValidMap[thingId]) {
          for (const email of customEmails) {
            result.push({
              alertType: 'custom-email',
              email: email.email,
              eventType: eventType,
              thingId: thingId
            });
          }
        }
      }
    }
    return result;
  }

  /**
   * Para obtener el total de cosas de la collection para el paginador de la tabla del ABM
   * @param {*} enterprises
   * @param {*} types
   * @param {*} typesEvents
   */
  async function getTotal(enterprises, types, typesEvents) {
    if (enterprises && types && typesEvents) {
      try {
        const response = await alertEventApi.getTotalCount(enterprises, types, typesEvents)
        return response.data
      } catch (exception) {
        console.log(exception)
        return 0
      }
    } else {
      return 0
    }
  }

  /**
   * Para eliminar una cosa
   */
  async function deleteOne(id) {
    try {
      const response = await alertEventApi.delete(id)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Para elimincación múltiple
   */
  async function deleteMany(ids) {
    try {
      const response = await alertEventApi.multipleDelete(ids)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Devuelve los datos de una cosa para el dialog de ABM
   * @param {*} id
   */
  async function getAlertEvent(id) {
    try {
      const response = await alertEventApi.getAlertEvent(id)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Crea una nueva cosa en la collection
   * @param {*} alertEvent a
   */
  async function create(alertEvent) {
    try {
      const response = await alertEventApi.create(alertEvent)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Actualiza una cosa existente en la collection
   * @param {*} thing
   */
  async function update(thing) {
    try {
      const response = await alertEventApi.update(thing)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /*
  {
  "0": {
    "thingId": "5f2c26f2116bc53550dd8fbc",
    "userId": "5dd678226057589f62c91fc3",
    "eventType": "STOPPED",
    "eventId": "5e5fcaf1a2c651e4d8fcced0",
    "alertType": "push"
  }
}
  */

  function processNotifications(notificationsData, notificationBody, notifications) {
    const result = [];
    const locale = localStorage.getItem('locale');
    if (notifications) {
      const userMap = getNotificationUserMap(notificationsData);
      for (const notification of notifications) {
        const userId = notification.userId || notification.email;
        if (userMap[userId] && userMap[userId].emailChecked) {
          result.push({ ...notification, alertType: "email", title: notificationBody.title, subject: notificationBody.subject, body: notificationBody.messageBody, locale: locale });
        }
        if (userMap[userId] && userMap[userId].pushChecked) {
          result.push({ ...notification, alertType: "push", title: notificationBody.title, subject: notificationBody.subject, body: notificationBody.messageBody, locale: locale });
        }
        if (userMap[userId] && userMap[userId].customEmail) {
          result.push({ ...notification, alertType: "custom-email", title: notificationBody.title, subject: notificationBody.subject, body: notificationBody.messageBody, locale: locale });
        }
      }
    }
    return result;
  }

  function getNotificationUserMap(notificationsData) {
    const map = {};
    if (notificationsData && notificationsData.length > 0) {
      for (const notificationData of notificationsData) {
        if (notificationData.isCustom) {
          map[notificationData.email] = { customEmail: true, title: notificationData.title, subject: notificationData.subject, messageBody: notificationData.messageBody };
        } else {
          map[notificationData.id] = { emailChecked: notificationData.emailChecked, pushChecked: notificationData.pushChecked, title: notificationData.title, subject: notificationData.subject, messageBody: notificationData.messageBody };
        }
      }
    }
    return map;
  }

  function getUsersIdNotificationsList(notifications, emails) {
    const result = [];
    if (notifications) {
      for (const notification of notifications) {
        if (notification.pushChecked || notification.emailChecked) {
          result.push({ id: notification._id, emailChecked: notification.emailChecked, pushChecked: notification.pushChecked });
        }
      }
    }
    if (emails && emails.trim()) {
      const emailList = emails.split(',');
      if (emailList && emailList.length > 0) {
        for (const email of emailList) {
          if (email) {
            result.push({ isCustom: true, email: email });
          }
        }
      }
    }
    return result;
  }

  function validateEmailList(value) {
    return !value || !value.trim() || EMAIL_LIST_REGEX.test(value);
  }

  return {
    findAll,
    findAllSuccessfulAlerts,
    getTotal,
    getAlertEvent,
    deleteOne,
    deleteMany,
    create,
    update,
    processNotifications,
    getUsersIdNotificationsList,
    validateEmailList,
    generateKey,
    findAlertsByKey
  }
})()
